import _ from "lodash";
import iconImage from "../assets/icon/collections-24px.svg";
import iconPdf from "../assets/icon/picture_as_pdf-24px.svg";
import iconAttachment from "../assets/icon/attach_file-24px.svg";
import { MediaObject } from "../types/MediaObject";
import { isLitigationCase } from "../types/AbstractCase";
import { BackofficeUser } from "../types/BackofficeUser";
import { STAGE_ACTION_REQUIRED, STAGE_DATA_COMPLETED } from "./Stages/StagesCase";
import { ProductUnion } from "../types/ProductUnion";
import dayjs from "dayjs";

export const FILE_SIZE_LIMIT_WARNING = 10_485_760;
export const FILE_SIZE_LIMIT_EXCEEDED = 20_971_520;
export const FILE_NAME_LENGTH_LIMIT = 70;
export const NO_LABEL_ACTION_IDENTIFIERS = ["NO_ACTION", "OPS_ACTIVITY", "LAWYER_ACTIVITY"];

export const filterByFolder = (mediaObjects: MediaObject[], folder: string) => {
  return _.filter(mediaObjects, (mediaObject) => {
    return !_.startsWith(mediaObject.electronicFileFolderPath ?? "", folder);
  });
};

export const getIcon = (mediaObject: MediaObject) => {
  switch (mediaObject.mimeType) {
    case "image/jpg":
    case "image/jpeg":
    case "image/png":
      return iconImage;
    case "application/pdf":
      return iconPdf;
    default:
      return iconAttachment;
  }
};

export const getMediaObjectFilters = (
  product: Pick<ProductUnion, "productClassName" | "id">,
  currentUser: BackofficeUser
) => {
  let mediaObjectsFilter: Partial<MediaObject> = {
    product: product.productClassName,
    productId: product.id
  };

  if (currentUser.isExternal) {
    mediaObjectsFilter.showInExternalView = true;
  }
  return mediaObjectsFilter;
};

export const getRenderValue = (mediaObjectIds: number[], mediaObjects: MediaObject[]) => {
  return _.map(
    mediaObjectIds,
    (mediaObjectId) => _.find(mediaObjects, (mediaObject) => mediaObject.id === mediaObjectId)?.description
  ).join(", ");
};

export const getMediaObjectFormattedDescription = (mediaObject: MediaObject) => {
  return mediaObject.description + " | " + dayjs(mediaObject.created).format("DD.MM.YYYY") || "Ohne Beschreibung";
};

export const isValidUploadableFile = (fileName: string, checkLength: boolean = true) => {
  return !(
    /[ ‚{}()%&@#$~!^?*<>,\\+:=/“;[\]|]/.test(fileName) ||
    (fileName.match(/\./g) || []).length > 1 ||
    (checkLength && fileName.length > FILE_NAME_LENGTH_LIMIT)
  );
};

export const getChangeFieldNameModalOptions = (
  product: ProductUnion,
  mediaObject: MediaObject
) => {
  let fieldNameOptions = [];

  if (
    product &&
    isLitigationCase(product) &&
    product.stage >= STAGE_DATA_COMPLETED &&
    product.stage <= STAGE_ACTION_REQUIRED
  ) {
    if (mediaObject.fieldname === "extrajudicialLetter") {
      fieldNameOptions.push({ id: "removedViaChangeFieldNameModal", label: "Keine Kennzeichnung" });
    } else {
      fieldNameOptions.push({ id: "extrajudicialLetter", label: "Außergerichtliches Schreiben" });
    }
  }

  return fieldNameOptions;
};
